var map = {
	"./IdChecks": 39365,
	"./IdChecks.vue": 39365,
	"./LawFirmTasks": 67079,
	"./LawFirmTasks.vue": 67079,
	"./ProofOfFunds": 53519,
	"./ProofOfFunds.vue": 53519,
	"./ProtocolPack": 86885,
	"./ProtocolPack.vue": 86885,
	"./SearchPack": 81312,
	"./SearchPack.vue": 81312,
	"./TA10": 37055,
	"./TA10.vue": 37055,
	"./TA6": 65729,
	"./TA6.vue": 65729,
	"./TA7": 32014,
	"./TA7.vue": 32014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11548;